module.exports = __webpack_public_path__ + "media/images/toggle_on-c90125a32d686d0a8d38ee83247b507c.png";